export default function Image({
  src,
  alt,
  width,
  height,
  lazy = true,
  ...rest
}) {

    
  return (
    <img
      src={src}
      alt={alt}
      width={width}
      height={height}
      loading={lazy ? "lazy" : undefined}
      {...rest}
    />
  );
}
